export const rcpValues = ["rcp26", "rcp45", "rcp60", "rcp85"] as const;

export type Rcp = (typeof rcpValues)[number];

export const DEFAULT_RCP: Rcp = "rcp85";

export const RCP_COLORS: Record<Rcp, string> = {
  rcp26: "#ffb300",
  rcp45: "#ff7d00",
  rcp60: "#e32685",
  rcp85: "#9d02d7",
};
